import { Box, Stack, Typography, Link } from "@mui/material";

/*
 * The same line at the bottom of every page.
 *
 * One component rather than a copy per screen: the landing page grew its own footer
 * first, and a second hand-written one is how the support address ends up correct in one
 * place and stale in another.
 *
 * It carries the one thing a stuck customer needs - who to write to - which is why it is
 * on the signed-in screens too and not only on the page that sells.
 */
export default function AppFooter() {
    return (
        <Box component="footer" sx={{
            mt: "auto", borderTop: "1px solid rgba(255,255,255,.07)",
            px: { xs: 2, md: 4, xl: 6 }, py: 3,
        }}>
            <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5}
                sx={{ justifyContent: "space-between", alignItems: { sm: "center" } }}>
                <Box component="img" src="/assets/iotmatrix-white.png" alt="iotmatrix"
                    sx={{ height: 24, opacity: .8 }} />
                <Typography sx={{ color: "rgba(255,255,255,.45)", fontSize: 13.5 }}>
                    © {new Date().getFullYear()} iotmatrix ·{" "}
                    <Link href="mailto:support@myiotplatform.in" underline="hover"
                        sx={{ color: "rgba(255,255,255,.6)" }}>
                        support@myiotplatform.in
                    </Link>
                </Typography>
            </Stack>
        </Box>
    );
}
